import styled from "styled-components";

export const SideBarWrap = styled.div`
  width: 280px;
  background: #495e66;
  height: calc(100vh - 74px);
  padding: 15px 15px;
  box-shadow: 0 0.5rem 1rem rgba(220, 195, 197, 0.75) !important;
  position: fixed;
  left: 0px;
  top: 120px;
  overflow: auto;
  @media only screen and (max-width: 991px) {
    display: none;
  }
`;

export const ListItemParent = styled.h4`
  font-size: 22px;
  color: #fff;
  cursor: pointer;
  transition-duration: 0.3s;
  font-size: 30px;
  font-weight: 600;
  text-align: center;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  transition-duration: 0.3s;
  padding: 5px;
  svg{
      margin-right: 10px;
  }
  &:hover {
    color: #8cc63f;
  }
`;



// WEBPACK FOOTER //
// ./src/component/SideBar/styles.js